import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';

import Header from './Components/Header';
import Footer from './Components/Footer';
import ScrollToTop from './Components/ScrollToTop';
import Home from './Pages/Home';
import About from './Pages/About';
import ServicesPage from './Pages/ServicesPage';
import Projects from './Pages/Projects';
import Gallery from './Pages/Gallery';
import Clients from './Pages/Clients';
import Contact from './Pages/Contact';
import useCardTilt from './hooks/useCardTilt';

function AnimatedRoutes() {
  const location = useLocation();
  const { pathname, search, hash } = location;

  if (pathname.length > 1 && pathname.endsWith('/')) {
    return <Navigate to={`${pathname.slice(0, -1)}${search}${hash}`} replace />;
  }

  return (
    <main key={pathname} className="page-enter">
      <Routes location={location}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </main>
  );
}

function App() {
  useCardTilt();

  return (
    <Router>
      <ScrollToTop />
      <Header />
      <AnimatedRoutes />
      <Footer />
    </Router>
  );
}

export default App;
